import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api/menuitem';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { UserAuthService } from 'src/app/services/user-auth/user-auth.service';
import { MsalService } from '@azure/msal-angular';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  loginMenuItems!: MenuItem[];
  userImage!: SafeUrl;
  loginDisplay = false;
  userName!: string;
  checkLoginStatusSvcSub!: Subscription;

  constructor(
    private readonly domSanitizer: DomSanitizer,
    private readonly userAuthSvc: UserAuthService,
    private readonly authService: MsalService
  ) {}

  ngOnInit(): void {
    this.loginMenuItems = [
      {
        label: `<button>Sign Out</button>`,
        escape: false,
        command: () => {
          this.logout();
        },
      },
    ];

    this.checkLoginStatusSvcSub = this.userAuthSvc
      .checkLoginStatus()
      .subscribe(() => {
        this.setLoginDisplay();
      });
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    if (this.loginDisplay) {
      this.userAuthSvc.getProfilePhoto().subscribe((blob) => {
        const urlCreator = window.URL || window.webkitURL;
        this.userImage = this.domSanitizer.bypassSecurityTrustUrl(
          urlCreator.createObjectURL(blob)
        );
      });
    }
  }

  logout() {
    this.userAuthSvc.getProfileDetails().subscribe((acc: any) => {
      this.userAuthSvc.activeUser.next(acc.userPrincipalName);
      const userAcc = this.authService.instance.getAccountByUsername(
        acc.userPrincipalName
      );
      if (userAcc) { 
        this.authService.logoutRedirect({
          account: userAcc,
        });
      }
    }, error => {
      console.error('Error in getProfileDetails:', error); 
    });
  }
}
